<template>
  <a href="javascript:;" title="Exportar" @click="modalOpen('code');codeSetupBox(box)" class="kp-select-open">
    <i class="kp-panel-import"></i>{{ $t('general.actions.export') }}
  </a>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  methods: mapActions([
    'modalOpen',
    'codeSetupBox',
  ]),
  props: [
    'box',
  ],
};
</script>



/** WEBPACK FOOTER **
 ** ButtonExport.vue?637cfcb3
 **/